import React, { useState, useEffect } from "react";
import "./IntegrationModals.css";
import { FaWhatsapp } from "react-icons/fa";
import { api } from "../../../services/api";
import { toast } from "react-toastify";

const EvolutionWhatsApp = ({
  isOpen,
  onClose,
  providerKey,
  integrationId,
  env = "production",
  onSave,
  credentials,
  showLabel = false,
  initialLabel = ""
}) => {
  const [form, setForm] = useState({
    token: "",
    instance_id: "",
    host: "",
  });
  const [label, setLabel] = useState(initialLabel);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (!isOpen) return;

    const cred = credentials?.summary;

    if (cred) {
      setForm({
        token: "",
        instance_id: cred.instance_id || "",
        host: cred.host || "",
      });
    } else {
      setForm({
        token: "",
        instance_id: "",
        host: "",
      });
    }
  }, [isOpen, integrationId, providerKey, credentials]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let finalIntegrationId = integrationId;
      let isNewIntegration = false;

      if (!finalIntegrationId) {
        const connectRes = await api.post(
          `/api/integrations/${providerKey}/connect`,
          { env }
        );
        const connectData = connectRes.data;
        finalIntegrationId = connectData.id;
        isNewIntegration = true;
      }

      const credentialsPayload = {
        host: form.host,
        instance_id: form.instance_id,
        webhook_url: null,
      };

      if (form.token) {
        credentialsPayload.token = form.token;
      }

      const payload = {
        credentials: credentialsPayload,
      };

      const credRes = await api.put(
        `/api/integrations/${finalIntegrationId}`,
        payload
      );

      const updatedIntegration = credRes.data;
      if (isNewIntegration) {
        toast.success("Credenciais do WhatsApp cadastradas com sucesso!");
      } else {
        toast.success("Credenciais do WhatsApp atualizadas com sucesso!");
      }

      if (typeof onSave === "function") {
        onSave(providerKey, updatedIntegration);
      }

      onClose();
    } catch (error) {

      let errorMessage = "Erro ao salvar credenciais do WhatsApp";

      if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (error.response?.data?.detail) {
        errorMessage = error.response.data.detail;
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = `Erro: ${error.message}`;
      }

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="int-modal-backdrop" onClick={onClose}>
      <div className="int-modal" onClick={(e) => e.stopPropagation()}>
        <div className="int-modal-header">
          <div className="int-modal-title-wrap">
            <FaWhatsapp className="int-channel-icon" />
            <div>
              <h3>WhatsApp Evolution</h3>
              <p>Configure aqui as credenciais da Evolution API.</p>
            </div>
          </div>
          <button
            type="button"
            className="int-modal-close"
            onClick={onClose}
            disabled={loading}
          >
            ✕
          </button>
        </div>

        <div className="int-modal-body">
          <p className="int-modal-description">
            Use sua API Key e dados da instância para conectar o FASTTEAM à
            Evolution API. Os dados são criptografados e usados apenas pelas
            automações.
          </p>

          <form onSubmit={handleSubmit} className="int-modal-form">
            {showLabel && (
              <div className="int-form-group">
                <label htmlFor="integration_label">Nome da Integração *</label>
                <input
                  id="integration_label"
                  name="integration_label"
                  type="text"
                  value={label}
                  onChange={(e) => setLabel(e.target.value)}
                  placeholder="Ex: WhatsApp Vendas"
                  required={showLabel}
                />
              </div>
            )}
            <div className="int-form-group">
              <label htmlFor="token">API Key *</label>
              <input
                id="token"
                name="token"
                type="text"
                value={form.token}
                onChange={handleChange}
                placeholder="Insira sua API Key aqui"
                required={!integrationId}
              />
            </div>

            <div className="int-form-group">
              <label htmlFor="instance_id">Nome da instância *</label>
              <input
                id="instance_id"
                name="instance_id"
                type="text"
                value={form.instance_id}
                onChange={handleChange}
                placeholder="Ex: fastteam_main_instance"
                required
              />
            </div>

            <div className="int-form-group">
              <label htmlFor="host">URL da Evolution API *</label>
              <input
                id="host"
                name="host"
                type="text"
                value={form.host}
                onChange={handleChange}
                placeholder="Ex: http://evolution-api:8080"
                required
              />
            </div>

            <div className="int-modal-footer">
              <button
                type="button"
                className="int-btn-outline"
                onClick={onClose}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="int-btn-primary"
                disabled={loading}
              >
                {loading
                  ? "Salvando..."
                  : integrationId
                    ? "Salvar alterações"
                    : "Conectar canal"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EvolutionWhatsApp;
